import React, { useState, useEffect } from 'react';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';
import { collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import DataTable from '../common/DataTable';
import { contactsService } from '../../services/contactsService';
import { salesService } from '../../services/salesService';
import DeliveryList from '../sales/DeliveryList';
import { downloadPDF } from '../../utils/pdfUtils';

export default function AssignedOrdersTab() {
  const [vehicles, setVehicles] = useState([]);
  const [orders, setOrders] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({});
  const [businessDetails, setBusinessDetails] = useState(null);

  const fetchVehicles = async () => {
    try {
      const vehiclesRef = collection(db, 'vehicles');
      const snapshot = await getDocs(vehiclesRef);
      const vehiclesList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setVehicles(vehiclesList);
    } catch (error) {
      console.error('Error fetching vehicles:', error);
    }
  };

  const fetchOrders = async () => {
    try {
      const pendingOrders = await salesService.getAllPendingOrders();
      setOrders(pendingOrders);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  const fetchCustomers = async () => {
    try {
      const customers = await contactsService.getContacts('customer');
      const customerDetailsMap = {};
      customers.forEach(customer => {
        customerDetailsMap[customer.id] = customer;
      });
      setCustomerDetails(customerDetailsMap);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const fetchBusinessDetails = async () => {
    try {
      const settingsRef = doc(db, 'settings', 'business');
      const settingsDoc = await getDoc(settingsRef);
      if (settingsDoc.exists()) {
        setBusinessDetails(settingsDoc.data());
      } else {
        console.error('Business settings not found');
      }
    } catch (error) {
      console.error('Error fetching business details:', error);
    }
  };

  useEffect(() => {
    fetchVehicles();
    fetchOrders();
    fetchCustomers();
    fetchBusinessDetails();
  }, []);

  // Filter vehicles to only show those with orders
  const vehiclesWithOrders = vehicles.filter(vehicle => 
    orders.some(order => order.vehicleId === vehicle.id)
  );

  const columns = [
    {
      header: 'Vehicle',
      cell: info => {
        const vehicle = info.row.original;
        return (
          <div>
            <div className="font-medium">{vehicle.registrationNumber}</div>
            <div className="text-sm text-gray-500">{vehicle.driverName}</div>
          </div>
        );
      },
    },
    {
      header: 'Orders',
      cell: info => {
        const vehicle = info.row.original;
        const vehicleOrders = orders.filter(order => order.vehicleId === vehicle.id);
        return (
          <div className="space-y-2">
            {vehicleOrders.map(order => (
              <div key={order.id} className="text-sm">
                <div className="font-medium">{order.customerName}</div>
                <div className="text-gray-500">
                  {order.items.map(item => 
                    `${item.vegetable} (${item.estimatedQuantity}kg)`
                  ).join(', ')}
                </div>
              </div>
            ))}
          </div>
        );
      },
    },
    {
      header: 'Actions',
      cell: info => {
        const vehicle = info.row.original;
        const vehicleOrders = orders.filter(order => order.vehicleId === vehicle.id);
        
        console.log('Vehicle:', vehicle);
        console.log('Vehicle Orders:', vehicleOrders);
        console.log('Customer Details:', customerDetails);
        
        return (
          <div className="flex space-x-2">
            <button
              onClick={async () => {
                console.log('Generating PDF with:', {
                  orders: vehicleOrders,
                  vehicle,
                  customerDetails,
                  businessDetails
                });
                
                const doc = (
                  <DeliveryList
                    orders={vehicleOrders}
                    date={new Date()}
                    customerDetails={customerDetails}
                    vehicle={vehicle}
                    businessDetails={{
                      name: businessDetails?.name || 'St George Vegetables',
                      address: businessDetails?.address || 'Kattappanna, Pin: 685515',
                      phone: businessDetails?.phone || '9544623341',
                      email: businessDetails?.email || 'stgeorgevegetable@gmail.com',
                      gstNumber: businessDetails?.gstNumber || '29ABCDE1234F1Z5',
                    }}
                  />
                );
                await downloadPDF(doc, `delivery-list-${vehicle.registrationNumber}-${new Date().toISOString().split('T')[0]}.pdf`);
              }}
              className="text-primary-600 hover:text-primary-900"
            >
              <ClipboardDocumentListIcon className="h-5 w-5" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <DataTable
        data={vehiclesWithOrders}
        columns={columns}
      />
    </div>
  );
}